import axios from '@/config/httpConfig'
// 里程碑排序查询页面
export function getMilestoneSort(data) {
    return axios.post("/projectGanttChart/getMilestoneSort", data)
}
// 保存任务或者里程碑的排序
export function saveMilestoneOrTaskSort(data) {
    return axios.post("/projectGanttChart/saveMilestoneOrTaskSort", data)
}
